class CollectionProductSearch extends HTMLElement {
  connectedCallback() {
    if (this.isInitialized) return;

    this.input = this.querySelector('input[type="search"]');
    this.status = this.querySelector('[role="status"]');
    this.gridContainer = document.getElementById('ProductGridContainer');

    if (!this.input || !this.status || !this.gridContainer) return;

    this.isInitialized = true;
    this.input.addEventListener('input', () => this.filterProducts());

    this.gridObserver = new MutationObserver(() => this.filterProducts());
    this.gridObserver.observe(this.gridContainer, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    if (this.gridObserver) this.gridObserver.disconnect();
  }

  normalize(value) {
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  filterProducts() {
    const grid = this.gridContainer.querySelector('#product-grid');
    if (!grid) return;

    const query = this.normalize(this.input.value);
    const searchTerms = query.split(/\s+/).filter(Boolean);
    const productCards = Array.from(grid.children).filter((item) => item.matches('li'));
    let visibleCount = 0;

    productCards.forEach((productCard) => {
      const titleElement = productCard.querySelector('.card__heading a');
      const title = this.normalize(titleElement ? titleElement.textContent : productCard.textContent);
      const matches = searchTerms.length === 0 || searchTerms.every((term) => title.includes(term));

      productCard.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    this.updateStatus(query, visibleCount);
    this.updateEmptyState(grid, query, visibleCount);
  }

  updateStatus(query, visibleCount) {
    if (!query) {
      this.status.hidden = true;
      this.status.textContent = '';
      return;
    }

    this.status.hidden = false;
    this.status.textContent = `${visibleCount} ${visibleCount === 1 ? 'product' : 'products'} found`;
  }

  updateEmptyState(grid, query, visibleCount) {
    const collectionContainer = grid.closest('.collection');
    if (!collectionContainer) return;

    let emptyState = collectionContainer.querySelector('[data-collection-search-empty]');

    if (!emptyState) {
      emptyState = document.createElement('p');
      emptyState.className = 'collection-product-search__empty';
      emptyState.dataset.collectionSearchEmpty = '';
      emptyState.textContent = 'No products match your search.';
      grid.before(emptyState);
    }

    emptyState.hidden = !query || visibleCount > 0;
  }
}

if (!customElements.get('collection-product-search')) {
  customElements.define('collection-product-search', CollectionProductSearch);
}
